import { ThemeOverride } from './types';
import { overrideDefaultTheme } from './theme';

export const override: ThemeOverride = {
  name: 'currys',
  colors: {
    light: '#ECF5FF'
  }
};

export default overrideDefaultTheme(override);
